import { AvisSimpleTable, IColumnConfig, IPaginatorPageChange } from "../";
import {
  IColumnConfigConditional,
  IPaginatedList,
} from "../../../../../models";

interface IAvisFilterableTableGridProps<T> {
  initData: IPaginatedList<T>;
  loading: boolean;
  tableColumns: IColumnConfig[];
  tableColumnWidths?: number[];
  conditionalFormatting?: IColumnConfigConditional<T>[];
  onPageChange: (e: IPaginatorPageChange | undefined) => void;
  customRowClassNames?: (rowData: T) => string;
}

export function AvisFilterableTableGrid<T extends object>(
  props: Readonly<IAvisFilterableTableGridProps<T>>,
) {
  const {
    initData,
    loading,
    tableColumns,
    tableColumnWidths,
    conditionalFormatting,
    onPageChange,
    customRowClassNames,
  } = props;

  const renderGrid = () => {
    if (!initData?.items) return;

    return (
      <AvisSimpleTable<T>
        columnMetadata={tableColumns}
        data={initData.items}
        loading={loading}
        onPage={onPageChange}
        first={initData.pageIndex * initData.pageSize}
        rows={initData.pageSize}
        totalRecords={initData.totalCount}
        columnWidths={tableColumnWidths}
        rowClassName={customRowClassNames}
        conditionalFormatting={conditionalFormatting}
      />
    );
  };

  return renderGrid();
}
